<template>
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.125 5.0415H3.20833V5.95817H4.125V5.0415ZM5.95833 5.0415H5.04167V5.95817H5.95833V5.0415ZM7.79167 5.0415H6.875V5.95817H7.79167V5.0415ZM8.70833 1.83317H8.25V0.916504H7.33333V1.83317H3.66667V0.916504H2.75V1.83317H2.29167C1.78292 1.83317 1.37958 2.24567 1.37958 2.74984L1.375 9.1665C1.375 9.40962 1.47158 9.64278 1.64349 9.81468C1.81539 9.98659 2.04855 10.0832 2.29167 10.0832H8.70833C9.2125 10.0832 9.625 9.67067 9.625 9.1665V2.74984C9.625 2.24567 9.2125 1.83317 8.70833 1.83317ZM8.70833 9.1665H2.29167V4.12484H8.70833V9.1665Z"
      fill="#98A7AD"
    />
  </svg>
</template>
<script>
export default {
  name: "DateIcon",
};
</script>
